import { combineReducers } from '@reduxjs/toolkit';
import { createStore as createCommonStore } from '@pwc/pwc-deals-web-common';
import { addMiddlewares } from './reduxMiddlewares';
import { history, staticReducers } from './reduxStaticReducers';

export const rootReducer = combineReducers(staticReducers);

export const createStore = () =>
  createCommonStore({
    staticReducers,
    middleware: addMiddlewares,
  });

export const store = createStore();

export const injectReducerAsync = store.injectReducer;

export { history };
